module.exports = __webpack_public_path__ + "img/452.2ab7f507.png";